// material-ui

import truckappointmentoverviewicon from '../../../assets/images/truck-appointment-overview.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const TruckAppointmentOverviewIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={truckappointmentoverviewicon} alt="Truck appointment Overview" width="22"  />
    );
};

export default TruckAppointmentOverviewIcon;